export default __webpack_public_path__ + "static/media/PaymentIn30Mins.d19082a2.svg";